export const articles = [
  {
    id: 1,
    title: '《咒术回战》为什么能成为现象级作品？深度解读其成功密码',
    excerpt: '从精致的战斗分镜到深刻的人物塑造，探索咒术回战如何在众多热血动漫中脱颖而出，成为新一代动漫爱好者的入坑神作。',
    content: `<p>《咒术回战》自连载以来，凭借其独特的世界观设定和出色的角色塑造，迅速在全球范围内积累了庞大的粉丝群体。这部作品的成功并非偶然，而是多方面因素的完美融合。</p>
<h2>独特的世界观设定</h2>
<p>咒术回战构建了一个基于"诅咒"的超自然世界。人类的负面情绪会凝聚成诅咒，而咒术师则是对抗这些诅咒的存在。这种设定既有日本传统妖怪文化的底蕴，又融入了现代都市的元素，让读者感到既熟悉又新奇。</p>
<h2>出色的角色群像</h2>
<p>主角虎杖悠仁并非传统意义上的"天选之子"。他善良、正直，但同时也面临着体内宿傩带来的巨大威胁。五条悟作为最强咒术师的设定更是打破了传统"师父角色"的刻板印象。每一个配角都有自己完整的故事线和成长轨迹，这让整个世界观显得更加立体。</p>
<h2>精彩的战斗设计</h2>
<p>芥见下下的战斗分镜被誉为新一代漫画家的标杆。每一场战斗都有清晰的逻辑推演，术式的运用充满创意。特别是"领域展开"的设定，将战斗推向了策略与美学的双重高度。</p>
<h2>深刻的主题探讨</h2>
<p>在热血战斗的外壳之下，《咒术回战》探讨了关于生死、正义与人性的深刻命题。"正确的死亡"这一概念贯穿始终，让读者在享受视觉盛宴的同时也能产生深层次的思考。</p>`,
    category: 'rexue',
    author: '动漫观察员',
    date: '2026-08-01',
    readTime: '8分钟',
    tags: ['咒术回战', '热血动漫', '深度解读'],
    coverUrl: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20anime%20analysis%20blog%20header%2C%20dark%20stylized%20illustration%20with%20cursed%20energy%20effects%2C%20minimalist%20composition%2C%20warm%20accent%20on%20dark%20background%2C%20editorial%20anime%20art%20style&width=800&height=450&seq=article-cover-01&orientation=landscape',
  },
  {
    id: 2,
    title: '2026年夏季新番推荐：这10部动漫绝对不容错过',
    excerpt: '夏季新番热潮来袭！从热血战斗到治愈日常，为你精选10部2026年夏季最值得追的动漫作品。',
    content: `<p>2026年夏季新番档期可以说是近年来最豪华的一季。续作与新作齐飞，各种类型应有尽有。下面就为大家盘点本季10部最值得关注的作品。</p>
<h2>续作篇：经典回归</h2>
<p>本季有多部备受期待的续作回归。《咒术回战 第三季》无疑是最大的看点，涉谷事变后的剧情走向令人揪心。《葬送的芙莉莲 第二季》延续第一季的高品质制作，继续讲述芙莉莲充满哲思的旅程。</p>
<h2>新作篇：惊喜连连</h2>
<p>新作方面同样精彩纷呈。改编自人气轻小说的《夏日幻影》以精致的画面和动人的故事吸粉无数。原创动画《星之轨迹》凭借大胆的艺术风格引发热议。</p>
<h2>黑马篇：意想不到的惊喜</h2>
<p>每季都有一些起初不被看好但最终逆袭的黑马作品。本季的《深夜咖啡厅》以温馨治愈的风格和细腻的情感描写，成为了本季最大的惊喜。</p>
<h2>追番指南</h2>
<p>建议优先关注制作阵容强大的作品，同时也不要忽视一些小众但口碑极佳的冷门佳作。合理安排追番时间，享受这个精彩的动漫之夏！</p>`,
    category: 'zixun',
    author: '新番猎人',
    date: '2026-07-28',
    readTime: '10分钟',
    tags: ['2026夏季新番', '追番推荐', '新番盘点'],
    coverUrl: 'https://readdy.ai/api/search-image?query=Summer%202026%20anime%20season%20collage%2C%20colorful%20various%20anime%20characters%20arrangement%2C%20bright%20summer%20vibe%20with%20warm%20sunlight%2C%20festive%20atmosphere%2C%20anime%20promotional%20art%20style&width=800&height=450&seq=article-cover-02&orientation=landscape',
  },
  {
    id: 3,
    title: '从《鬼灭之刃》看日本动漫的全球影响力',
    excerpt: '《鬼灭之刃 无限城篇》即将上映，回顾这部作品如何打破文化壁垒，在全球范围内引发动漫热潮。',
    content: `<p>《鬼灭之刃》系列自2019年动画化以来，已经成为了一个跨越国界的文化现象。从日本本土到北美、欧洲、东南亚，这部作品的影响力远超一般动漫的范畴。</p>
<h2>文化共鸣的力量</h2>
<p>《鬼灭之刃》虽然深深植根于日本传统文化——鬼杀队的剑术、呼吸法、以及大正时代的背景设定，但其核心主题——家人之间的羁绊、面对逆境不屈的精神——具有普世价值，能够引起全球观众的共鸣。</p>
<h2>制作水准的标杆</h2>
<p>ufotable的制作水准为行业树立了新的标杆。浮世绘风格的视觉呈现、流畅华丽的战斗场景、以及椎名豪创作的配乐，共同打造了一场视听盛宴。</p>
<h2>市场表现的奇迹</h2>
<p>《鬼灭之刃 无限列车篇》以超过500亿日元的票房成为日本影史票房冠军，这一成就证明了动漫作品在主流市场的巨大潜力。</p>`,
    category: 'zixun',
    author: '动漫产业观察',
    date: '2026-07-20',
    readTime: '6分钟',
    tags: ['鬼灭之刃', '日本动漫', '全球影响力'],
    coverUrl: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20global%20impact%20editorial%20header%2C%20Japanese%20traditional%20pattern%20background%2C%20warm%20red%20and%20gold%20accents%2C%20elegant%20minimalist%20composition%2C%20magazine%20feature%20anime%20art%20style&width=800&height=450&seq=article-cover-03&orientation=landscape',
  },
  {
    id: 4,
    title: '国产动漫崛起：2026年最值得期待的5部国漫大作',
    excerpt: '国漫近年来质量飞速提升，从画面到剧情都有了质的飞跃。盘点2026年最值得期待的国漫作品。',
    content: `<p>中国动漫产业在过去几年经历了翻天覆地的变化。从《哪吒之魔童降世》到《深海》，国漫在技术和艺术层面都展现出了令人惊叹的进步。</p>
<h2>技术飞跃：画面质量的质变</h2>
<p>2026年的国漫在3D渲染技术上取得了重大突破。《仙剑奇侠传》动画版的人物建模和场景渲染已经达到了国际一流水准，光影效果的运用更是让人眼前一亮。</p>
<h2>内容深度：讲好中国故事</h2>
<p>国漫不再只是简单地堆砌特效，而是更加注重故事的内核。《山海经之重启》将中国古代神话与现代叙事手法相结合，打造出了既有文化底蕴又不失现代感的作品。</p>
<h2>产业生态：从单打独斗到集群发展</h2>
<p>国漫产业链日趋完善，从IP孵化、制作到衍生品开发，整个生态正在快速成熟。越来越多的资本和人才涌入这个领域，为国漫的未来发展注入了强大动力。</p>`,
    category: 'guoman',
    author: '国漫观察',
    date: '2026-07-15',
    readTime: '7分钟',
    tags: ['国漫', '国产动漫', '2026推荐'],
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20rise%20editorial%20header%2C%20traditional%20Chinese%20ink%20painting%20style%20blended%20with%20modern%20anime%2C%20warm%20red%20and%20gold%20color%20scheme%2C%20elegant%20composition%2C%20cultural%20anime%20art&width=800&height=450&seq=article-cover-04&orientation=landscape',
  },
  {
    id: 5,
    title: '动漫配乐大赏：那些让人一听就起鸡皮疙瘩的神曲',
    excerpt: '一部优秀的动漫离不开出色的配乐。盘点那些让人难以忘怀的动漫音乐，每一首都承载着无数回忆。',
    content: `<p>动漫配乐是作品灵魂的重要组成部分。一首好的配乐能够瞬间将观众拉入故事的氛围中，甚至在多年后再次听到时依然能够唤起当初的感动。</p>
<h2>战斗场景的高燃配乐</h2>
<p>提到热血配乐，泽野弘之的名字必不可少。《进击的巨人》中的「at'aek ON taitn」和《青之驱魔师》的多首配乐都成为了动漫音乐的经典。林友树为《排球少年》创作的配乐也同样让人热血沸腾。</p>
<h2>催泪名场面配乐</h2>
<p>Key社作品的配乐素以催泪著称。麻枝准创作的《CLANNAD》配乐「渚」和「小さな手のひら」至今仍是催泪神曲。梶浦由记为《魔法少女小圆》创作的配乐更是将悲剧氛围推向了极致。</p>
<h2>日常治愈系配乐</h2>
<p>《摇曳露营》和《日常》的配乐以轻松温馨的风格著称。这些配乐不需要华丽的编曲，简单的旋律就能让人感受到生活的美好。</p>`,
    category: 'zixun',
    author: '音乐宅',
    date: '2026-07-08',
    readTime: '9分钟',
    tags: ['动漫配乐', '音乐盘点', '动漫音乐'],
    coverUrl: 'https://readdy.ai/api/search-image?query=Anime%20soundtrack%20music%20theme%20editorial%20header%2C%20musical%20notes%20with%20anime%20visual%20elements%2C%20warm%20golden%20and%20pink%20gradient%2C%20dreamy%20atmosphere%2C%20elegant%20minimalist%20music%20anime%20art&width=800&height=450&seq=article-cover-05&orientation=landscape',
  },
  {
    id: 6,
    title: '从零开始的动漫入坑指南：新手必看的入门神作',
    excerpt: '想开始看动漫但不知道从何下手？这份入门指南为你推荐最适合新手的10部动漫作品。',
    content: `<p>动漫世界浩瀚如海，对于刚接触动漫的新手来说，选择合适的入坑作品至关重要。一部好的入门作品能够让你快速爱上动漫，而一部不合适的作品可能会让你望而却步。</p>
<h2>热血入门：《钢之炼金术师FA》</h2>
<p>被誉为"零差评神作"的《钢之炼金术师FA》，以完整的叙事结构和深刻的主题成为最适合入门的作品之一。64集的篇幅不长不短，剧情节奏完美，人物塑造饱满。</p>
<h2>治愈入门：《夏目友人帐》</h2>
<p>如果你偏好温馨治愈的风格，《夏目友人帐》是绝佳的选择。每一集都是独立的小故事，讲述了人与妖怪之间的温情羁绊。</p>
<h2>推理入门：《死亡笔记》</h2>
<p>高智商对决的巅峰之作，剧情紧凑扣人心弦。L与夜神月的智斗精彩绝伦，让无数观众一口气追完。</p>
<h2>情感入门：《四月是你的谎言》</h2>
<p>音乐与青春交织的感人故事，精美的画面和动人的配乐相得益彰。准备好纸巾，这将是一次难忘的观看体验。</p>`,
    category: 'zixun',
    author: '动漫导航员',
    date: '2026-06-30',
    readTime: '8分钟',
    tags: ['入坑指南', '入门推荐', '新手必看'],
    coverUrl: 'https://readdy.ai/api/search-image?query=Anime%20beginner%20guide%20editorial%20header%2C%20warm%20welcoming%20atmosphere%2C%20various%20anime%20DVD%20cases%20arrangement%2C%20cozy%20reading%20nook%20with%20soft%20lighting%2C%20inviting%20anime%20art%20style&width=800&height=450&seq=article-cover-06&orientation=landscape',
  },
];

export const getArticleById = (id: number) => articles.find(a => a.id === id);

export const getRelatedArticles = (currentId: number, maxCount: number = 3) =>
  articles.filter(a => a.id !== currentId).slice(0, maxCount);

export const getArticlesByCategory = (categorySlug: string) =>
  articles.filter(a => a.category === categorySlug);